import { NodeSection } from "../props/node/constants";
export var ChangeStyleVisitor = {
  Node: {
    enter: function enter(path, state) {
      var nodeId = state.opts.nodeId;
      if (path.params.nodeId !== nodeId) this.skip();
    },
    enterChild: function enterChild(path) {
      if (path.params.section !== NodeSection.STYLES) this.skip();
    }
  },
  StylesDecorator: {
    enter: function enter(path, state) {
      var styleId = state.opts.styleId;
      if (!path.node.hasChild(styleId)) {
        this.executeChange(function () {
          path.node.pushChild(styleId);
        });
      }
    },
    enterChild: function enterChild(path, state) {
      var styleId = state.opts.styleId;
      if (path.params.styleId !== styleId) this.skip();
    }
  },
  AdaptiveDecorator: {
    enterChild: function enterChild(path, state) {
      if (!path.params.matchesInterval(state.opts)) this.skip();
    }
  },
  Value: function Value(path, state) {
    var value = state.opts.value;
    this.executeChange(function () {
      path.node.setValue(value);
    });
  }
};